export default __webpack_public_path__ + "static/media/avatar_tommy_pyper7.926e1f29.mp3";